import React from 'react';
interface Achievement {
  image: string;
  title: string;
  subtitle?: string;
}
const achievements: Achievement[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/2SX7hfPZCUXRa3WSTjUbLm/35mesto.webp',
  title: '35. mesto od 1217 fotografov',
  subtitle: '(mednarodna udeležba) po presoji J. Polin slike leta 2023'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/uHiFdRuZ9eFjEzrRiFLnPf/prva-slo-rally-knjiga.webp',
  title: 'Avtor prve Slovenske rally foto knjige 2024',
  subtitle: 'M. Čendak in J. Markežič'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/3Lowc8tqS4JmEGFiAG6xfh/potna-knjiga-optimized.webp',
  title: 'Avtor naslovne slike potne knjige Rally Idrija 2024'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/tXeKzizpaoDWSB9TAVkaJi/ponovno_avtor_slike_na_potni_knjigi_rallya_idrija_2025.jpg',
  title: 'Ponovno avtor slike na potni knjigi Rally Idrija 2025'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jrCCLxdn5jAL9yt8RaF7Lp/_MG_2702.jpg',
  title: 'Uradni fotograf Slovenskega dvojca Čendak&Markežič v sezoni 2025'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/wbPz27NuNXDGcQPTc1yAqX/studijska-fotografija.webp',
  title: 'Studijska fotografija'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jdxmR6iot8k2vKCJHJYVuP/drugi-utrinki.webp',
  title: 'Avtor še in še ujetih trenutkov svojega in tujega življenja'
}];
export function AchievementsSection() {
  return <section id="dosezki" className="bg-neutral-950 py-16 sm:py-24 px-4 sm:px-6 lg:px-8" data-id="element-22">
      <div className="mx-auto max-w-7xl" data-id="element-23">
        <div className="mb-10 sm:mb-16 text-center" data-id="element-24">
          <h2 className="text-2xl sm:text-3xl font-light text-white sm:text-4xl" data-id="element-25">
            Dosežki &{' '}
            <span className="font-serif italic text-neutral-400" data-id="element-26">
              Priznanja
            </span>
          </h2>
          <div className="mt-4 h-px w-24 bg-neutral-800 mx-auto" data-id="element-27"></div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-28">
          {achievements.map((item, index) => <div key={index} className="group relative overflow-hidden bg-neutral-900" data-id="element-29">
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden" data-id="element-30">
                <img src={item.image} alt={item.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-31" />
              </div>

              {/* Content */}
              <div className="p-4 sm:p-6" data-id="element-32">
                <h3 className="text-base sm:text-lg font-light leading-snug text-white" data-id="element-33">
                  {item.title}
                </h3>
                {item.subtitle && <p className="mt-1 sm:mt-2 text-xs sm:text-sm text-neutral-400" data-id="element-34">
                    {item.subtitle}
                  </p>}
              </div>

              {/* Subtle border on hover */}
              <div className="absolute inset-0 border border-transparent transition-colors duration-300 group-hover:border-neutral-700 pointer-events-none" data-id="element-35" />
            </div>)}
        </div>
      </div>
    </section>;
}